import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, setAuthToken } from "../lib/api";
import { toast } from "sonner";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // If already logged in, jump to dashboard
    if (localStorage.getItem("twr_admin_token")) {
      api.get("/auth/me").then(() => navigate("/admin/dashboard")).catch(() => setAuthToken(null));
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      setAuthToken(r.data.token);
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error("Invalid credentials.");
    } finally { setLoading(false); }
  };

  return (
    <section className="min-h-screen flex items-center justify-center px-6 bg-[#0A0A0A]" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-block mb-12"><Logo variant="vertical" /></Link>
        <p className="eyebrow">Admin Access</p>
        <h1 className="font-serif text-4xl mt-3">Sign in</h1>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <label className="block">
            <span className="eyebrow">Email</span>
            <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-3 w-full bg-transparent border border-[var(--twr-line-strong)] focus:border-[var(--twr-bronze)] outline-none px-4 py-3 text-sm" />
          </label>
          <label className="block">
            <span className="eyebrow">Password</span>
            <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-3 w-full bg-transparent border border-[var(--twr-line-strong)] focus:border-[var(--twr-bronze)] outline-none px-4 py-3 text-sm" />
          </label>
          <button disabled={loading} data-testid="admin-login-submit" className="btn-bronze w-full">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <div className="flex items-center gap-4 my-8">
          <div className="flex-1 h-px bg-[var(--twr-line-strong)]" />
          <span className="text-[var(--twr-warm-white)]/40 text-[11px] tracking-[0.22em] uppercase">or</span>
          <div className="flex-1 h-px bg-[var(--twr-line-strong)]" />
        </div>
        <button
          type="button"
          data-testid="admin-google-login"
          onClick={() => {
            // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
            const redirectUrl = window.location.origin + "/admin/dashboard";
            window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
          }}
          className="w-full flex items-center justify-center gap-3 border border-[var(--twr-line-strong)] hover:border-[var(--twr-bronze)] hover:text-[var(--twr-bronze)] transition-colors px-4 py-3.5 text-[12px] tracking-[0.22em] uppercase"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="#EA4335" d="M12 5.04c1.62 0 3.06.56 4.2 1.64l3.12-3.12C17.4 1.79 14.94.75 12 .75 7.44.75 3.52 3.36 1.6 7.16l3.66 2.84C6.16 7.16 8.84 5.04 12 5.04z"/><path fill="#4285F4" d="M23.25 12.27c0-.86-.08-1.68-.22-2.47H12v4.68h6.32c-.27 1.46-1.1 2.7-2.34 3.53l3.6 2.79c2.1-1.95 3.67-4.82 3.67-8.53z"/><path fill="#FBBC05" d="M5.26 14.29a7.06 7.06 0 0 1 0-4.58L1.6 6.87a11.26 11.26 0 0 0 0 10.26l3.66-2.84z"/><path fill="#34A853" d="M12 23.25c3.04 0 5.6-1 7.46-2.72l-3.6-2.79c-1 .68-2.3 1.08-3.86 1.08-3.16 0-5.84-2.12-6.74-4.97l-3.66 2.84c1.92 3.8 5.84 6.56 10.4 6.56z"/></svg>
          Continue with Google
        </button>
        <p className="text-[var(--twr-warm-white)]/40 text-[11px] mt-8">Authorised personnel only.</p>
      </div>
    </section>
  );
}
